import { frontendURL } from '../../../../helper/URLHelper';
import PostSaleAnalysisPage from '../pages/PostSaleAnalysisPage.vue';
import NucleoWorkOrderRequestPage from '../pages/NucleoWorkOrderRequestPage.vue';
import SalesReviewPage from '../pages/SalesReviewPage.vue';
import PostSaleIndex from '../pages/PostSaleIndex.vue';
import PostSaleSalesDetailPage from '../pages/PostSaleSalesDetailPage.vue';
import PostSaleStatusPage from '../pages/PostSaleStatusPage.vue';
import { postSalePermissions } from './permissions';

export const postSaleEntryRoutes = [
  {
    path: frontendURL(
      'accounts/:accountId/operacao-imobiliaria/pos-venda/:postSaleCaseId/analise'
    ),
    alias: [
      frontendURL(
        'accounts/:accountId/operacao-imobiliaria/posvenda/:postSaleCaseId/analise'
      ),
      frontendURL('accounts/:accountId/pos-venda/:postSaleCaseId/analise'),
      frontendURL('accounts/:accountId/posvenda/:postSaleCaseId/analise'),
    ],
    name: 'operacao_imobiliaria_pos_venda_analise',
    component: PostSaleAnalysisPage,
    meta: { permissions: postSalePermissions },
  },
  {
    path: frontendURL(
      'accounts/:accountId/operacao-imobiliaria/pos-venda/:salesTransactionId/pedidos-servico'
    ),
    alias: [
      frontendURL(
        'accounts/:accountId/operacao-imobiliaria/posvenda/:salesTransactionId/pedidos-servico'
      ),
      frontendURL(
        'accounts/:accountId/pos-venda/:salesTransactionId/pedidos-servico'
      ),
      frontendURL(
        'accounts/:accountId/posvenda/:salesTransactionId/pedidos-servico'
      ),
    ],
    name: 'operacao_imobiliaria_pos_venda_pedidos_servico',
    component: NucleoWorkOrderRequestPage,
    meta: { permissions: postSalePermissions },
  },
];

export const postSaleReturnRoutes = [
  {
    path: frontendURL(
      'accounts/:accountId/operacao-imobiliaria/pos-venda/:salesTransactionId/devolucao'
    ),
    alias: [
      frontendURL('accounts/:accountId/posvenda/:salesTransactionId/devolucao'),
      frontendURL(
        'accounts/:accountId/pos-venda/:salesTransactionId/devolucao'
      ),
    ],
    name: 'operacao_imobiliaria_pos_venda_devolucao',
    component: SalesReviewPage,
    meta: { permissions: postSalePermissions },
  },
];

export const postSaleMainRoutes = [
  {
    path: frontendURL('accounts/:accountId/operacao-imobiliaria/pos-venda'),
    alias: [
      frontendURL('accounts/:accountId/operacao-imobiliaria/posvenda'),
      frontendURL('accounts/:accountId/pos-venda'),
      frontendURL('accounts/:accountId/posvenda'),
      frontendURL('accounts/:accountId/post-sale'),
    ],
    name: 'operacao_imobiliaria_pos_venda',
    component: PostSaleIndex,
    meta: { permissions: postSalePermissions },
  },
  {
    path: frontendURL(
      'accounts/:accountId/operacao-imobiliaria/pos-venda/:postSaleCaseId/detalhes-venda'
    ),
    alias: [
      frontendURL(
        'accounts/:accountId/operacao-imobiliaria/posvenda/:postSaleCaseId/detalhes-venda'
      ),
      frontendURL(
        'accounts/:accountId/pos-venda/:postSaleCaseId/detalhes-venda'
      ),
      frontendURL(
        'accounts/:accountId/posvenda/:postSaleCaseId/detalhes-venda'
      ),
    ],
    name: 'operacao_imobiliaria_pos_venda_detalhes',
    component: PostSaleSalesDetailPage,
    meta: { permissions: postSalePermissions },
  },
  {
    path: frontendURL(
      'accounts/:accountId/operacao-imobiliaria/pos-venda/:postSaleCaseId/status'
    ),
    alias: [
      frontendURL(
        'accounts/:accountId/operacao-imobiliaria/posvenda/:postSaleCaseId/status'
      ),
      frontendURL('accounts/:accountId/pos-venda/:postSaleCaseId/status'),
      frontendURL('accounts/:accountId/posvenda/:postSaleCaseId/status'),
    ],
    name: 'operacao_imobiliaria_pos_venda_status',
    component: PostSaleStatusPage,
    meta: { permissions: postSalePermissions },
  },
];
